module.exports = __webpack_public_path__ + "static/media/detail-empretec-startup-mobile.97c1b4ef.png";